import {useState, useEffect} from 'react';
import ModalSuccess from "../components/Modal/ModalSuccess";
import {saveRatingToLocal, saveRatingToAPI} from '../services/RatingService';
import {useUser} from "../contexts/UserContext";

const useRating = (initialValue, rateTargetId, onRatingChange) => {
    const {user} = useUser();
    const [rating, setRating] = useState(initialValue);
    const [isRatingSaved, setIsRatingSaved] = useState(false);
    const [error, setError] = useState(null);
    const [userHasInteracted, setUserHasInteracted] = useState(false);

    useEffect(() => {
        if (userHasInteracted && !isRatingSaved) {
            try {
                const saveRating = process.env.REACT_APP_MODE === 'maquette' ? saveRatingToLocal : saveRatingToAPI;
                saveRating(+rating, +rateTargetId)
                    .then((savedData) => {
                        if (savedData.success === true || savedData.success === 'true') {
                            setIsRatingSaved(true);
                            onRatingChange("Merci pour votre retour sur cette séance.");
                        } else {
                            setRating(initialValue);
                            setError(savedData.msg);
                        }
                    })
                    .catch((err) => {
                        setError(err.msg);
                    });
            } catch (error) {
                setError(error.msg);
            }
        }
    }, [rating, rateTargetId, onRatingChange, initialValue, isRatingSaved, userHasInteracted]);

    useEffect(() => {
        setRating(initialValue);
        setUserHasInteracted(false);
    }, [initialValue]);

    const handleRatingChange = (newValue) => {
        setRating(newValue);
        setIsRatingSaved(false);
        setUserHasInteracted(true);
    };

    return [rating, handleRatingChange, error, setUserHasInteracted];
};

export default useRating;
